<div class="modal-header">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button tabindex=0 role=button type="button" class="close pull-right" aria-label="Close" (click)="hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body dialogBoxScroll"  [innerHtml]='content'>
</div>